import './AsyncSaveButton.scss';

import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { AsyncSaveButtonProps } from 'types/Common.types';

/**
 * Button that displays a loading icon and content while asynchronous saving is in progress
 */
const AsyncSaveButton = (props: AsyncSaveButtonProps) => {
  const {
    inProgress = false,
    inProgressIcon = <CircularProgress size='1rem' color='inherit' disableShrink />,
    inProgressContent,
    buttonProps,
    children,
  } = props;

  return (
    <Button
      {...buttonProps}
      className={`async-save-button ${buttonProps.classes ?? ''}`}
      endIcon={inProgress ? inProgressIcon : buttonProps.endIcon}
    >
      {inProgress ? inProgressContent : children}
    </Button>
  );
};

export default AsyncSaveButton;
